/**
 * 運営商品一覧画面の検索クラス
 *
 * @export SearchOperationGoodsListModel
 * @class SearchOperationGoodsListModel
 */
export class SearchOperationGoodsListModel {
  /** 宅配業態. */
  public deliveryDiv: string = <string>'';
  /** 注文コード */
  public orderNum: string;
  /** 受注企画回*/
  public orderCatalog: string;
  /** 運営企画区分. */
  public planningManagementDiv: string = <string>'';
  /** 運営企画詳細区分. */
  public planningManagementDetailDiv: string = <string>'';
  /** 商品名. */
  public goodsName:string = <string>'';
  /** 規格名. */
  public standardName: string = <string>'';
  // ページ
  public page: string = <string>'';
}
